import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import {Grid} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import 'date-fns'

import {
    Button,
    LoonsSnackbar,
    MainContainer,
    LoonsCard,
    CardTitle,
    SubTitle,
    FilePicker
} from 'app/components/LoonsLabComponents'
import { orgType, user_roles } from 'appconst'
import OrganizationServices from '../../services/OrganizationServices'
import { Link } from 'react-router-dom'
import ConfigurationServices from 'app/services/ConfigurationServices'

const styleSheet = (theme) => ({})

class AddNewOrg extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeStep: 1,
            isUpdate: false,
            data: [],
            catId: null,
            isLoaded: false,
            message:'',
            severity:'success',
            loading: false,
            file: { fileList: [] },
            file2: { fileList: [] },
            formData: {
                orgName: null,
                OrgAcronym:null,
                description: null,
                orgtype: null,
                website: null,
                contact_no: null,
                email: null,
                address: null,
                profilepic: null,
                coverpic:null
            },
            filterData: {
                limit: 10,
                page: 0,
            },
            totalItems: 0,
            totalPages: 0,
            tableDataLoaded: false,
        }
    }

    selectedFiles(files) {
        console.log("fil1")
        this.setState({ file: files }, () => { this.loadFile() })
    }
    selectedFiles2(files) {
        console.log("fil2", files)
        this.setState({ file2: files })
    }

    handleRedirect = () => {
        setTimeout(() => {
            this.props.history.push('/Organization/OrgManagement')
            console.log('timeout')
        }, 2000);
    }

    addNewOrganization = async (formData) => {
        let res = await OrganizationServices.addNewOrganization(formData)
        console.log('res', res)
        if (res.status === 201) {
            this.setState({
                alert: true,
                message:
                    'Your request submitted!',
                severity:'success',
            })
            // this.handleRedirect()
        } else if(res.status === 401 & res.data.msg.includes("Organization name already exist")) {
            this.setState({
                alert: true,
                message: 'The organization name you added is already existing in the system. Kindly select the correct organization from the dropdown and register as a user',
                severity:'error',
            })
        } else if(res.status === 401 & res.data.msg.includes("Organization email already exist")) {
            this.setState({
                alert: true,
                message: 'The organization email you added is already existing in the system',
                severity:'error',
            })
        } else {
            this.setState({
                alert: true,
                message: 'New organization creation was unsuccessful!',
                severity:'error',
            })
        }
    }

    isBelong = (event) => {
        this.setState({isUpdate: !this.state.isUpdate})
    }


    handleDataSubmit = async () => {

        var formData = new FormData()
        // let files = []
        // this.state.files.fileList.forEach(element => {

        //    // files.push(element.file)
        //    form_data2.append(`file`, element.file);
        // });
      
        formData.append(`organizationName`, this.state.formData.orgName)
        formData.append(`organizationAcronym`, this.state.formData.OrgAcronym)
        formData.append(`description`, this.state.formData.description)
        formData.append(`organizationTypeId`, this.state.formData.orgtype)
        formData.append(`website`, this.state.formData.website)
        formData.append(`telephone`, this.state.formData.contact_no)
        formData.append(`email`, this.state.formData.email)
        formData.append(`address`, this.state.formData.address)
        formData.append(`profilepic`, this.state.file.fileList[0]?.file)
        formData.append(`coverpic`, this.state.file2.fileList[0]?.file)
        
        this.addNewOrganization(formData)
        console.log("fd : ",this.state.formData)
    }

    getOrganizationTypeConfig = async () => {
        this.setState({ loaded: false })
        let res = await ConfigurationServices.getOrganizationConfig()
        if(res?.data){
            this.setState({ data: res.data, loaded: true })
        }
        console.log("data: ",this.state.data)
    }

    componentDidMount() {
        this.getOrganizationTypeConfig()
     }
    
    async setPage(page) {
        let filterData = this.state.filterData
        filterData.page = page
        this.setState(
            {
                filterData,
            },
            () => {
                this.fetchDataSet()
            }
        )
    }

    onInputChange =(event) => {}

    render() {
        let { theme } = this.props
        const { classes } = this.props

        return (
            <Fragment>
                <MainContainer>
                    <LoonsCard>
                        <CardTitle title="Add New Organization" className=""/>

                        <ValidatorForm 
                            className="pt-2"
                            onSubmit={() => this.handleDataSubmit()}
                            onError={() => null}
                        >
                            {/* Main Grid */}
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                className="mt-3"
                            >
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Grid container spacing={2}>
                                        {/* heading */}

                                        <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                            <Grid container spacing={2}>
                                                
                                                {/* Organization name */}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                                                                      
                                                    <SubTitle
                                                        title="Organization Name" 
                                                        required= {true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter the organization name"
                                                        name="orgName"
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .orgName
                                                        }
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    orgName: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^[a-zA-Z0-9 ]{1,160}$'
                                                        ]}
                                                        errorMessages={[
                                                            'Organization Name is required',
                                                            'Enter a valid organization name'
                                                            
                                                        ]}
                                                    />
                                                </Grid>

                                                {/* Organization Acronym */}
                                                <Grid
                                                        className=" w-full"
                                                        item
                                                        lg={6}
                                                        md={6}
                                                        sm={12}
                                                        xs={12}
                                                    >
                                                  
                                                    <SubTitle title="Organization Acronym"/>
                                              
                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="eg:UNDP"
                                                        name="OrgAcronym"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData.OrgAcronym
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    OrgAcronym: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'matchRegexp:^[a-zA-Z]{1,8}$'
                                                        ]}
                                                        errorMessages={[
                                                            'Enter a valid organization acronym'
                                                            
                                                        ]}
                                                        
                                                    />
                                                </Grid>
                                               

                                                {/* Description*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    
                                                    <SubTitle
                                                        title="Description" 
                                                        required= {true}    
                                                    />
                                                        
                                                    <TextValidator
                                                        className="w-full"
                                                        placeholder="Short summary about the organization"
                                                        name="description"
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData.description
                                                        }
                                                        type="text"
                                                        multiline
                                                        rows={3}
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    description: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            // 'matchRegexp:^[a-zA-Z0-9 ]{1,500}$'
                                                            
                                                        ]}
                                                        errorMessages={[
                                                            'Organization Description is required',
                                                            // 'Enter a valid description'
                                                        ]}
                                                    />
                                                </Grid>

                                                {/* Organization Type*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    
                                                    <SubTitle
                                                        title="Organization Type" 
                                                        required= {true}    
                                                    />


                                                    <Autocomplete
                                                        className=" w-full"
                                                        options={this.state.data}
                                                        value={this.state.data.find(
                                                            (item)=> (item.id==this.state.formData?.orgtype)
                                                        )}
                                                        name="orgType"
                                                        
                                                        getOptionLabel={(option) => option.orgName ? option.orgName:''}
                                                        renderInput={(
                                                            params
                                                        ) => (
                                                            <TextValidator
                                                                {...params}
                                                                placeholder="Select the organization type"
                                                                variant="outlined"
                                                                type="text"
                                                                size="small"
                                                                fullWidth
                                                                value={
                                                                    this.state.formData.orgtype
                                                                }
                                                                
                                                                validators={[
                                                                    'required',
                                                                ]}
                                                                errorMessages={[
                                                                    'Organization Type is required',
                                                                ]}
                                                        
                                                            />   
                                                        )}
                                                        onChange={(e, newValue) => {
                                                            if (newValue != null && newValue !=undefined) {
                                                                this.setState({
                                                                    formData: {
                                                                        ...this.state.formData,
                                                                        orgtype: newValue.id,
                                                                    },
                                                                })
                                                            }
                                                        }}
                                                    />                                                     
                                                </Grid>

                                                {/* Website*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle title="Website" />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Website link of the organization"
                                                        name="website"
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .website
                                                        }
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    website: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            // 'matchRegexp:/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi'
                                                            'matchRegexp:^[^ ]{0,}$'
                                                            
                                                        ]}
                                                        errorMessages={[
                                                            'Enter a valid website link'
                                                        ]}
                                                       
                                                    />
                                                </Grid>

                                                {/* Telephone*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    
                                                    <SubTitle
                                                        title="Telephone" 
                                                        required= {true}    
                                                    />
                                                        
                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Telephone number of the organization with country code (Ex: +94761350100)"
                                                        name="contact_no"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData.contact_no
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    contact_no: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^[+]{1}[0-9]{11,15}$'
                                                        ]}
                                                        errorMessages={[
                                                            'Telephone Number is required',
                                                            'Enter a valid telephone number with country code'
                                                        ]}
                                                    />
                                                </Grid>

                                                {/* Email*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle title="Email" required/>

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Email address of the organization"
                                                        name="email"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData.email
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    email: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'isEmail'
                                                        ]}
                                                        errorMessages={[
                                                            'Email is required',
                                                            'Email is not valid'
                                                        ]}
                                                        
                                                    />
                                                </Grid>

                                                {/* Address*/}
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    
                                                    <SubTitle
                                                        title="Address" 
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Address of the organization"
                                                        name="address"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData.address
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    address: e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                        ]}
                                                        errorMessages={[
                                                            'Address is required',
                                                        ]}
                                                    />
                                                </Grid>

                                                {/* Upload Profile Picture*/}
                                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                                    <SubTitle title="Upload Profile Picture/ Logo" required/>
                                                    <FilePicker
                                                        className="w-full mt-2"
                                                        id=" profilepic"
                                                        multipleFileEnable={false}
                                                        dragAndDropEnable={true}
                                                        //tableEnable={false}
                                                        documentName={false}
                                                        // documentNameValidation={['required']}
                                                        // documenterrorMessages={['This field is required']}
                                                        accept="image/png, image/jpeg, image/jpg"
                                                        maxFileSize={20480000}
                                                        maxTotalFileSize={409600000}
                                                        maxFilesCount={1}
                                                        validators={['required','maxSize', 'maxTotalFileSize', 'maxFileCount']}
                                                        errorMessages={['This field is required',"file size too lage", "Total file size is too lage", "Too many files added"]}
                                                        // validators={['required', 'maxSize', 'maxTotalFileSize', 'maxFileCount']}
                                                        // errorMessages={['this field is required', "file size too lage", "Total file size is too lage", "Too many files added"]}
                                                        label=""
                                                        singleFileButtonText="Select File"
                                                        //multipleFileButtonText="Select Files"
                                                        selectedFileList={this.state.file.fileList}
                                                        selectedFiles={(files) => {
                                                            console.log('fffffffffffff',files)
                                                            this.setState({ file: files })
                                                        }}
                                                    />
                                                    
                                                </Grid>


                                                {/* Upload Cover Image*/}
                                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                                    <SubTitle title="Upload Cover Image" />
                                                    <FilePicker
                                                        className="w-full mt-2"
                                                        id="coverpic"
                                                        multipleFileEnable={false}
                                                        dragAndDropEnable={true}
                                                        //tableEnable={false}
                                                        documentName={false}
                                                        documentNameValidation={['required']}
                                                        documenterrorMessages={['This field is required']}
                                                        accept="image/png, image/jpeg"
                                                        maxFileSize={20480000}
                                                        maxTotalFileSize={4096000000}
                                                        maxFilesCount={1}
                                                        validators={['maxSize', 'maxTotalFileSize', 'maxFileCount']}
                                                        errorMessages={["file size too lage", "Total file size is too lage", "Too many files added"]}
                                                        // validators={['required', 'maxSize', 'maxTotalFileSize', 'maxFileCount']}
                                                        // errorMessages={['this field is required', "file size too lage", "Total file size is too lage", "Too many files added"]}
                                                        label=""
                                                        singleFileButtonText="Select File"
                                                        multipleFileButtonText="Select Files"
                                                        selectedFileList={this.state.file2.fileList}
                                                        selectedFiles={(files) => {
                                                            this.setState({ file2: files })
                                                        }}
                                                    />
                                                </Grid>


                                            </Grid>

                                            <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        lg={12}
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        className=" w-full"
                                                    >
                                                        {/* Submit Button */}
                                                        <Button
                                                            className="mt-2 mr-2"
                                                            color="primary"
                                                            progress={false}
                                                            type="submit"
                                                            // scrollToTop={true}
                                                            startIcon="save"
                                                        //onClick={this.handleChange}
                                                        >
                                                            <span className="capitalize">
                                                                Submit
                                                            </span>
                                                        </Button>

                                                        {/* Cancel Button */}
                                                        <Link to='/Organization/OrgManagement'>
                                                        <Button
                                                            className="mt-2 ml-2"
                                                            color="secondary"
                                                            progress={false}
                                                            type="cancel"
                                                            // scrollToTop={true}
                                                            startIcon="close"
                                                        //onClick={this.handleChange}
                                                        >
                                                            <span className="capitalize">
                                                                Cancel
                                                            </span>
                                                        </Button>
                                                        </Link>    
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </ValidatorForm>
                    </LoonsCard>
                </MainContainer>

                <LoonsSnackbar
                    open={this.state.alert}
                    onClose={() => {
                        this.setState({ alert: false })
                    }}
                    message={this.state.message}
                    autoHideDuration={3000}
                    severity={this.state.severity}
                    elevation={2}
                    variant="filled"
                ></LoonsSnackbar>
            </Fragment>
        )
    }
}

export default withStyles(styleSheet)(AddNewOrg)
